import React, { Component } from "react";
import { connect } from "react-redux";
import Content from "./Content";
import Navbar from "./Navbar";
import { actions } from "../../../store/modules";
import { Layout } from 'antd';

class DashboardLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingAccount: true,
      loadingUser: true,
      sidebarVisible: false,
      isPopupModelVisble: false
    };
  }

  componentDidMount() {
    this.getAccount();
  }

  getAccount = () => {

    this.props.dispatch(actions.auth.getAccount())
      .then((response) => {
        this.setState({
          loadingAccount: false
        })
      }).catch(error => {
        this.logout();
      });
  };

  logout = () => {
    this.props.dispatch(actions.auth.logout())
  }

  render() {
    return (
      <Layout className="layout">
        <Navbar />
        <Content />
      </Layout>
    );
  }
}

const mapStateToProps = ({ auth, membership }) => ({ ...auth, ...membership });
export default connect(mapStateToProps)(DashboardLayout);



// WEBPACK FOOTER //
// ./src/components/App/Layout/Layout.js